import { faLocationDot } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { cn } from '@pickleballinc/ui/lib/utils';

interface Team {
	name: string;
	logo?: string;
	rating: string;
	isHome: boolean;
}

interface NewScheduleCardProps {
	date: string;
	eventTitle: string;
	awayTeam: Team;
	homeTeam: Team;
	location: string;
	className?: string;
}

export const NewScheduleCard = ({ date, eventTitle, awayTeam, homeTeam, location, className = '' }: NewScheduleCardProps) => {
	return (
		<div className={cn('bg-white rounded-lg border border-gray-200 p-4', className)}>
			<div className="mb-4">
				<div className="text-sm text-gray-500 mb-1">{date}</div>
				<div className="text-sm text-gray-500">{eventTitle}</div>
			</div>

			<div className="mb-4">
				<div className="block md:hidden">
					<div className="flex items-center gap-3 mb-3">
						{awayTeam.logo && (
							<span className="inline-block align-middle w-32 h-16 rounded-sm bg-white">
								<img src={awayTeam.logo} alt={awayTeam.name} className="w-full h-full object-contain rounded-sm" />
							</span>
						)}
						<div>
							<div className="text-base font-medium text-orange-500">{awayTeam.name}</div>
							<div className="text-sm text-gray-500">
								Away <span className="ml-1">#{awayTeam.rating}</span>
							</div>
						</div>
					</div>

					<div className="flex items-center justify-center mb-3">
						<div className="flex-1 h-px" style={{ backgroundColor: '#FFE6D5' }}></div>
						<span className="text-sm text-gray-500 font-medium px-4">vs</span>
						<div className="flex-1 h-px" style={{ backgroundColor: '#FFE6D5' }}></div>
					</div>

					<div className="flex items-center gap-3">
						{homeTeam.logo && (
							<span className="inline-block align-middle w-32 h-16 rounded-sm bg-white">
								<img src={homeTeam.logo} alt={homeTeam.name} className="w-full h-full object-contain rounded-sm" />
							</span>
						)}
						<div>
							<div className="text-base font-medium text-orange-500">{homeTeam.name}</div>
							<div className="text-sm text-gray-500">
								Home <span className="ml-1">#{homeTeam.rating}</span>
							</div>
						</div>
					</div>
				</div>

				<div className="hidden md:flex items-center gap-6">
					<div className="flex items-center gap-3">
						{awayTeam.logo && (
							<span className="inline-block align-middle w-32 h-16 rounded-sm bg-white">
								<img src={awayTeam.logo} alt={homeTeam.name} className="w-full h-full object-contain rounded-sm" />
							</span>
						)}
						<div>
							<div className="text-base font-medium text-orange-500">{awayTeam.name}</div>
							<div className="text-sm text-gray-500">
								Away <span className="ml-1">#{awayTeam.rating}</span>
							</div>
						</div>
					</div>

					<span className="text-sm text-gray-500 font-medium">vs</span>

					<div className="flex items-center gap-3">
						{homeTeam.logo && (
							<span className="inline-block align-middle w-32 h-16 rounded-sm bg-white">
								<img src={homeTeam.logo} alt={homeTeam.name} className="w-full h-full object-contain rounded-sm" />
							</span>
						)}
						<div>
							<div className="text-base font-medium text-orange-500">{homeTeam.name}</div>
							<div className="text-sm text-gray-500">
								Home <span className="ml-1">#{homeTeam.rating}</span>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="flex items-center gap-2 text-sm text-gray-500">
				<FontAwesomeIcon icon={faLocationDot} className="h-4 w-4 text-gray-400" />
				<span>{location}</span>
			</div>
		</div>
	);
};
